<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <v-container
        class="Kanit px-5"
        grid-list-xs
        style="padding-bottom: 70px; position: relative"
      >
        <div style="text-align: center" class="py-2 mb-3">
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <transition :name="transitionname" mode="in-out">
          <div :key="1" class="transition" v-if="step == 1">
            <h2 v-if="!noheader" style="color: #0c4d9d" class="mb-8">
              ลงทะเบียน
            </h2>
            <div class="slide-item">
              <ValidationObserver ref="observer">
                <ValidationProvider
                  :name="'เบอร์โทรศัพท์'"
                  :rules="'required|min:10'"
                  key="phoneno"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    class="mt-4"
                    type="number"
                    v-model="input.phoneno"
                    placeholder="เบอร์โทรศัพท์"
                    :error-messages="wrongphone ? wrongphone : errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div @click="saveData" v-ripple class="addcartbtn Kanit myshadow">
              <p v-if="!saveloading">ยืนยัน</p>
              <div v-else>
                <v-progress-circular
                  indeterminate
                  size="35"
                  color="white"
                ></v-progress-circular>
              </div>
            </div>
          </div>
          <div :key="2" class="transition" v-if="step == 2">
            <h2 style="color: #0c4d9d" class="mb-8">กรอก OTP</h2>
            <div class="slide-item">
              <div class="text-center mx-5">
                <div class="font-weight-bold mb-1">
                  กรุณากรอก OTP ที่ได้รับทาง SMS
                </div>
                <div class="mb-2">(Ref: {{ otpref }})</div>
                <ValidationObserver ref="observerotp">
                  <ValidationProvider
                    name="รหัส OTP"
                    :rules="{
                      required: true,
                      min: 5,
                    }"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      v-model="otp"
                      @input="
                        otp = removeHiddenSpace($event);
                        wrongotp = '';
                      "
                      maxlength="6"
                      :success="wrongotp ? false : valid"
                      :error-messages="wrongotp ? wrongotp : errors"
                      v-uppercase
                      outlined
                      placeholder="OTP: XXXXXX"
                    ></v-text-field>
                  </ValidationProvider>
                </ValidationObserver>
                <!-- <a :style="sendedOtp?`color: grey`:''" @click="resendOtp">
                Resend OTP
                <div>(ขอส่งใหม่ได้ทุก 60 วินาที)</div>
              </a>-->
                <div
                  @click="verifyOTP"
                  v-ripple
                  class="addcartbtn Kanit myshadow"
                >
                  <p v-if="!saveloading">ยืนยัน</p>
                  <div v-else>
                    <v-progress-circular
                      indeterminate
                      size="35"
                      color="white"
                    ></v-progress-circular>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";

export default {
  props: {
    noheader: {
      default: false,
    },
  },
  components: {
    Loading,
  },
  data() {
    return {
      input: {
        phoneno: "",
        email: "",
        // password: "",
        // confirmpassword: "",
      },
      // showPassword1: false,
      // showPassword2: false,
      otpref: "",
      wrongphone: "",
      otp: "",
      wrongotp: "",
      loading: true,
      sendedOtp: false,
      transitionname: "slidedealer",
      step: 1,
      saveloading: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  mounted() {
    var vm = this;
    if (
      ["dealer", "customer", "painter", "customerform"].includes(
        vm.$store.state.registerType
      )
    ) {
      vm.input.phoneno = vm.removeHiddenSpace(
        vm.$store.state.registerData.phoneno
      );
      vm.input.email = vm.removeHiddenSpace(vm.$store.state.registerData.email);
      vm.$nextTick(() => {
        if (vm.input.phoneno && vm.input.email) {
          vm.saveData();
        }
      });
    } else {
      vm.loading = false;
    }
  },
  methods: {
    async verifyOTP() {
      if (!this.saveloading) {
        var vm = this;
        const isValid = await this.$refs.observerotp.validate();
        if (isValid) {
          vm.saveloading = true;
          var data = {
            code: vm.removeHiddenSpace(this.otp),
            userid: this.$store.state.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            reference: this.otpref,
            phone_number: vm.removeHiddenSpace(this.input.phoneno),
            // password: this.input.password,
            user_type: [this.query.user_type],
            longitude: 103.26135156165,
            latitude: 10.12465165158,
            key: "$2y$10$HqV2f.V.3QFT1xMyGR5EielRACJuTAu3aJiM8Wh45CU3ESpHQa/Iy",
            email: vm.removeHiddenSpace(vm.input.email),
          };
          vm.toaregistermember(data);
        }
      }
    },
    async toadealerregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaregister",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              await vm.$liff.closeWindow();
              resolve();
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              resolve();
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ลงทะเบียนไม่สำเร็จ",
              });
              resolve();
            }
          });
      });
    },
    async toaregistermember(data) {
      var vm = this;

      axios
        .post(
          "https://communitybotbyzwizai.herokuapp.com/toaregistermember",
          data,
          { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            if (response.data.password) {
              var logindata = {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                phoneno: this.input.phoneno,
                password: response.data.password,
                email: vm.removeHiddenSpace(vm.input.email),
              };
              axios
                .post(
                  "https://communitybotbyzwizai.herokuapp.com/toaloginmember",
                  logindata,
                  {
                    headers: { AUTHORIZATION: "Bearer xxx xxx" },
                  }
                )
                .then(async (response) => {
                  this.saveloading = false;
                  if (response.data.responsecode == 200) {
                    if (vm.$store.state.registerType == "dealer") {
                      await vm.toadealerregister(vm.$store.state.registerData);
                    } else if (vm.$store.state.registerType == "customer") {
                      await vm.toacustomerConsent();
                      await vm.toacustomerregister(
                        vm.$store.state.registerData
                      );
                    } else if (vm.$store.state.registerType == "customerform") {
                      await vm.toacustomerConsent();
                      await vm.toacustomerform(vm.$store.state.registerData);
                    } else if (vm.$store.state.registerType == "painter") {
                      await vm.toapainterregister(vm.$store.state.registerData);
                    } else if (vm.$store.state.redirect) {
                      vm.query.view = vm.$store.state.redirect;
                    } else if (vm.query.user_type == "customer") {
                      vm.query.view = "CustomerForm";
                    } else {
                      vm.query.view = "Register";
                    }
                  }
                });
            } else {
              this.saveloading = false;
              vm.$swal.fire({
                icon: "error",
                text: "ลงทะเบียนไม่สำเร็จ",
              });
            }
          }
        });
    },
    async toapainterregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaregisterpainter",
            data,
            { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
          )
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "สำเร็จ",
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
              //   this.query.view = "SelectPainter";
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              vm.$store.state.redirect = "PainterForm";
              resolve();
            }
          });
      });
    },
    // resendOtp() {},
    async saveData() {
      var vm = this;
      var isValid = null;

      if (
        ["dealer", "customer", "painter", "customerform"].includes(
          vm.$store.state.registerType
        )
      ) {
        isValid = true;
      } else {
        isValid = await this.$refs.observer.validate();
      }
      if (isValid && !this.saveloading) {
        this.saveloading = true;
        axios
          .post("https://d-api.toapoints.com/api/v1/auth/login-phone", {
            phone_number: this.input.phoneno,
          })
          .then(async (response) => {
            vm.loading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            }
            vm.saveloading = false;
            vm.wrongphone = "";
            vm.otpref = response.data.data.reference;
            vm.step = 2;
          })
          .catch(async (err) => {
            vm.saveloading = false;
            await vm.$swal.fire({
              text: err.response.data.message,
            });
            if (
              err.response.data.message == "เบอร์โทรศัพท์นี้ได้ถูกลงทะเบียนแล้ว"
            ) {
              vm.query.view = "Login";
            }
            vm.wrongphone = err.response.data.message;
          });
      }
    },
    toacustomerregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toainfocustomer-createaddress",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            vm.saveloading = false;
            vm.$store.state.redirect = "";
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              await vm.$swal.fire({
                text: "เพิ่มที่อยู่สำเร็จ",
                icon: "success",
              });
              vm.query.view = "CustomerAddress";
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              resolve();
            }
          });
      });
    },
    toacustomerConsent() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaconsent",
            vm.$store.state.consentData,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
            if (response.data.responsecode == 200) {
              resolve();
            }
          });
      });
    },
    async toacustomerform(data) {
      var vm = this;

      vm.saveloading = true;

      axios
        .post(
          "https://communitybotbyzwizai.herokuapp.com/toapainterjobinfo",
          data,
          { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
        )
        .then(async (response) => {
          vm.$store.state.redirect = "";
          vm.saveloading = false;
          if (response.data.responsecode == 200) {
            this.$store.state.orderid = response.data.data[0].orderid;
            await this.$swal.fire({
              icon: "success",
              text: "สำเร็จ",
            });
            if (this.query.apptype == "line") {
              await this.$liff.closeWindow();
            } else if (this.query.apptype == "facebook") {
              this.$store.dispatch("messengerClose");
            }
            // this.query.view = "SelectPainter";
          } else {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
          }
        });
    },
  },
};
</script>